import {SketchPicker} from "react-color";
import reactCSS from "reactcss";

const ColorSegmentList = ({ colorSegments, setColorSegments }) => {

    const colorStyle = function (color) {
        return {
            // width: '100%',
            // height: '1.2em',
            // borderRadius: '2px',
            // border: '1px solid rgba(240, 240, 240, 240)',
            background: 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + color.a + ')',
            // margin: 0
        };
    };

    const styles = reactCSS({
        'default': {
            swatch: {
                paddingLeft: '5px',
                paddingRight: '5px',
                background: 'inherit',
                borderRadius: '1px',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '3',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
            btnDeleteStyle: {
                color: "#ffffff",
                background: "#6ba9db",
                padding: ".2rem",
                border: "1px solid #6ba9db",
                borderRadius: ".25rem",
                fontSize: "0.8rem",
                lineHeight: 1.0
            }
        },
    });

    const handleChangeColorSegmentValue = (selectSegment) => (e) => {
        const newColorSegments = colorSegments.map(function (segment) {
            if (segment.id === selectSegment.id) {
                segment.value = e.target.value;
            }
            return segment;
        });
        setColorSegments(newColorSegments);
    }

    const handleClickColorPicker = (selectSegment) => (e) => {
        const newColorSegments = colorSegments.map(function (segment) {
            if (segment.id === selectSegment.id) {
                segment.displayColorPicker = !segment.displayColorPicker;
            }
            return segment;
        });
        setColorSegments(newColorSegments);
    };

    const handleChangeColorPicker = (selectSegment) => (color,e) => {
        const newColorSegments = colorSegments.map(function (segment) {
            if (segment.id === selectSegment.id) {
                segment.color = color.rgb;
            }
            return segment;
        });

        setColorSegments(newColorSegments);
    };

    const handleCloseColorPicker = (selectSegment) => (e) =>{
        const newColorSegments = colorSegments.map(function (segment) {
            if (segment.id === selectSegment.id) {
                segment.displayColorPicker = false;
            }
            return segment;
        });

        setColorSegments(newColorSegments);
    };

    const handleClickColorSegmentDelete = (selectSegment) => (e) => {
        const newColorSegments = colorSegments.filter(segement => segement.id !== selectSegment.id)
        setColorSegments(newColorSegments);
    }

    return (
        <ul>
        {
            // "컬러세그먼츠"
            colorSegments.map(function (segment) {
                return (
                    <li key={segment.id}>
                        <div className="w1">
                            <input type="text" value={segment.value} onChange={handleChangeColorSegmentValue(segment)}/>
                            { //rgb선택창 팝업
                                segment.displayColorPicker ? <div style={styles.popover}>
                                    <div style={styles.cover} onClick={handleCloseColorPicker(segment)}/>
                                    <SketchPicker disableAlpha={true} color={segment.color}
                                                  onChange={handleChangeColorPicker(segment)}/>
                                </div> : null
                            }
                        </div>
                        <div className="w2">
                            <span className="color" onClick={handleClickColorPicker(segment)} style={colorStyle(segment.color)}></span>
                        </div>
                        <div className="w3">
                            <a href="javascript:;" className="btn_del01" onClick={handleClickColorSegmentDelete(segment)}><span className="blind">삭제</span></a>
                        </div>
                    </li>
                )
            })
        }
        </ul>
    );
}

export default ColorSegmentList;